/** Read a file as raw base64 (no `data:` prefix) plus MIME from the file or data URL. */
export function readFileAsRawBase64(file: File): Promise<{ base64: string; mimeType: string | null }> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => {
      const t = String(fr.result ?? "");
      const m = /^data:([^;]*);base64,(.*)$/s.exec(t);
      if (m) {
        resolve({
          base64: m[2].replace(/\s/g, ""),
          mimeType: (m[1] || file.type || "").trim() || null,
        });
      } else {
        const idx = t.indexOf("base64,");
        const rawB64 = idx >= 0 ? t.slice(idx + "base64,".length).replace(/\s/g, "") : t.replace(/\s/g, "");
        resolve({ base64: rawB64, mimeType: file.type || null });
      }
    };
    fr.onerror = () => reject(fr.error ?? new Error("Could not read file"));
    fr.readAsDataURL(file);
  });
}
